import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MijnInterfaceCacheService } from '@ap/mijn-interface-cache';

import {
    ContractDetails,
    HuismapResult,
    LijstVanProducten,
    LijstVanProductGroepen,
    OpenstaandeOpdrachten,
    ProductGroep,
    ZelfRegelenDetails
} from './mijn-overzicht.model';

@Injectable({ providedIn: 'root' })
export class MijnOverzichtResource {
    private readonly baseUrl = '/services-gwc/mijn-overzicht/api';

    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly mijnCacheService: MijnInterfaceCacheService = inject(MijnInterfaceCacheService);

    public getProducten(productGroups: Array<ProductGroep> = [], ibans?: string[]): Observable<LijstVanProducten> {
        const copyProductGroups: Array<string> = productGroups.map((product) => {
            if (product === ProductGroep.SPAREN) {
                return 'sparen&met_hoofdspaarpot=true';
            }
            return product;
        });

        let groups = '';
        let joinedIbans = '';
        if (copyProductGroups.length > 0) {
            groups = `?productgroep=${copyProductGroups.join('&productgroep=')}`;
        }
        if (ibans) {
            joinedIbans = `${copyProductGroups.length > 0 ? '&' : '?'}ibans=${ibans?.join()}`;
        }

        const params = new HttpParams({
            fromString: `${groups}${joinedIbans}`
        });

        return this.mijnCacheService.getData<LijstVanProducten>(this.baseUrl, 'producten', 3, params);
    }

    public getKindProducten(): Observable<LijstVanProducten> {
        return this.mijnCacheService.getData<LijstVanProducten>(this.baseUrl, 'kind-producten', 300);
    }

    public getProductGroepen(): Observable<LijstVanProductGroepen> {
        return this.mijnCacheService.getData<LijstVanProductGroepen>(this.baseUrl, 'productgroepen');
    }

    public getOpenstaandeOpdrachten(): Observable<OpenstaandeOpdrachten> {
        return this.httpClient.get<OpenstaandeOpdrachten>(`${this.baseUrl}/openstaande-opdrachten`);
    }

    public getContractDetails(): Observable<ContractDetails> {
        return this.mijnCacheService.getData<ContractDetails>(this.baseUrl, 'contract-details');
    }

    public getZelfRegelenDetails(): Observable<ZelfRegelenDetails> {
        return this.mijnCacheService.getData<ZelfRegelenDetails>(this.baseUrl, 'zelf-regelen-details', 3);
    }

    public getHuismap(): Observable<HuismapResult> {
        return this.mijnCacheService.getData<HuismapResult>(this.baseUrl, 'huismap', 300);
    }
}
